import parse from 'html-react-parser';
import cn from 'classnames';
import { useRef } from 'react';
import { Title } from '../Title/Title';
import { BannerLinks } from './components/BannerLinks';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import styles from './Banner.module.scss';

export const Banner = ({ title, text, isMobileSmallText, isMobileInnerAlign = 'middle' }) => {
    const lightingRef = useRef(null);
    const breakpoint = useBreakpoint();

    const mouseMoveHandler = (event) => {
        const rect = lightingRef.current.getBoundingClientRect()
        const right = rect.right + rect.width * .25
        const x = event.clientX

        if (x >= rect.left && x <= right) {
            lightingRef.current.style.setProperty('--lighting-key', Math.floor((x - rect.left) / (right - rect.left) * 61))
        } else if (x < rect.left) {
            lightingRef.current.style.setProperty('--lighting-key', 0)
        } else if (x > right) {
            lightingRef.current.style.setProperty('--lighting-key', 61)
        }
    }

    return (
        <div 
            className={ styles.banner }
            onMouseMove={ mouseMoveHandler }
        >
        <div
            className={ cn(
                styles.inner, {
                    [styles[isMobileInnerAlign]]: isMobileInnerAlign && isMobileInnerAlign !== 'middle'
                }
            ) }
        >
            { breakpoint === 'desktop' && (
                <div ref={ lightingRef } className={ styles.lighting } />
            ) }
            <Title texts={ title } isBig={ (isMobileSmallText && breakpoint === 'mobile') ? false : true } />
            { (isMobileSmallText && breakpoint === 'mobile') && (
                <div ref={ lightingRef } className={ styles.lighting } />
            ) }
        </div>
        { text ? (
            <p className={ styles.text }>{ parse(text) }</p>
        ) : (
            <BannerLinks />
        ) }
        </div>
    )
}
